<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $t('messages.syllabus'),
                        href: null,
                    },
                    {
                        name: $tc('messages.dimensions', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="w-full flex space-x-4 justify-end">
            <AppButton :href="meta.links.evaluation_criteria_index" element="inertia-link">
                {{ $tc('messages.evaluation_criteria', 2) }}
            </AppButton>
        </div>

        <Tabs :default-index="stages.findIndex((s) => s.first)">
            <Tab :title="stage.display_name" v-for="stage in stages" :key="stage.id">
                <Tabs>
                    <Tab
                        :title="category.name"
                        :selected="categoryIndex === 0"
                        v-for="(category, categoryIndex) in stage.categories"
                        :key="category.id"
                    >
                        <h6 class="text-xl font-semibold text-gray-900">
                            {{ category.name }}
                        </h6>
                        <template v-for="dimension in category.dimensions">
                            <details class="w-full pt-5">
                                <summary>
                                    {{ dimension.abbreviation }} -
                                    {{ dimension.title }}
                                </summary>
                                <p class="whitespace-pre-line">{{ dimension.description || '-' }}</p>
                            </details>
                            <ul>
                                <li class="ml-5 list-disc" v-for="competence in dimension.competences">
                                    {{ competence.abbreviation }} -
                                    {{ competence.description }}
                                </li>
                            </ul>
                        </template>
                    </Tab>
                </Tabs>
            </Tab>
        </Tabs>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import Tabs from '@/components/Tabs.vue';
import Tab from '@/components/Tab.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        PanelPage,
        Tabs,
        Tab,
        AppButton,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'stages', 'filters', 'options'],
    data() {
        return {};
    },
    methods: {},
};
</script>
